import {getCart} from './cart';
import {publishMenuOpened, publishCartDrawerViewed, publishSearchOpened} from './customer-events';

const labModal = (() => {
  function lockBodyScroll() {
    document.body.classList.add('modal-open', 'no-scroll');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('modal-open', 'no-scroll');
  }

  function registerCloseButtons() {
    document.addEventListener('click', (e) => {
      const el = e.target;
      const modalEl = el.closest('#modal-popup');
      if (!modalEl) return;
      if (
        el.getAttribute('id') === 'modal-popup__content' ||
        (el.closest('#modal-popup__content') && !el.classList.contains('modal-popup__close'))
      )
        return;

      // Close all modals
      const modals = document.querySelectorAll('[data-modal-id]');
      modals.forEach((modal) => {
        modal.classList.remove('open');
        unlockBodyScroll();
      });
    });
  }

  function closeModals() {
    const modals = document.querySelectorAll('#modal-popup[data-modal-id]');

    modals.forEach((modal) => {
      modal.classList.remove('open');
      unlockBodyScroll();
      document.documentElement.style.setProperty('--header-transform', 'translateY(0)');
    });
  }

  function registerModal(modalId, modalTrigger) {
    const modal = document.querySelector(`#modal-popup[data-modal-id="${modalId}"]`);

    return new Promise((resolve) => {
      const open = () => {
        closeModals();

        modalTrigger?.classList.add('open');
        modal.classList.add('open');
        lockBodyScroll();
        document.dispatchEvent(new CustomEvent('modal:open', {detail: modal}));
      };

      const close = () => {
        modalTrigger?.classList.remove('open');
        modal.classList.remove('open');
        unlockBodyScroll();
      };

      window.modals = window.modals || [];
      window.modals[modalId] = {
        open,
        close,
      };

      registerCloseButtons();

      if (window.modals?.[modalId]) resolve();
    });
  }

  function registerTriggers() {
    const triggers = document.querySelectorAll('#modal-trigger');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', async () => {
        const modalId = trigger.getAttribute('data-modal-id');

        if (trigger.classList.contains('open')) {
          window?.modals?.[modalId].close();
          return;
        }

        if (!window?.modals?.[modalId]) {
          await registerModal(modalId, trigger);
        }

        window?.modals?.[modalId].open();
      });
    });
  }

  function registerModalsWithoutTrigger() {
    const modals = document.querySelectorAll('#modal-popup');

    modals.forEach((modal) => {
      const modalId = modal.getAttribute('data-modal-id');
      const trigger = document.querySelector(`#modal-trigger[data-modal-id="${modalId}"]`);

      // We register the cart because it can be triggered by function (add to cart...) without clicking on the cart icon
      if (modalId !== 'cart' && trigger) return;

      registerModal(modalId);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    registerModalsWithoutTrigger();
    registerTriggers();
  });

  async function cartDrawerViewed() {
    try {
      const customData = await getCart();
      publishCartDrawerViewed(customData);
    } catch (error) {
      console.error(error);
    }
  }

  document.addEventListener('modal:open', (event) => {
    if (event.detail.getAttribute('data-modal-id') === 'cart') {
      cartDrawerViewed();
    } else if (event.detail.getAttribute('data-modal-id') === 'drawer-menu') {
      publishMenuOpened();
    } else if (event.detail.getAttribute('data-modal-id') === 'search') {
      publishSearchOpened();
    }
  });
})();

export default labModal;
